<template>
  <div class="desktop-only">
    <NavPage v-if="!isMapFullscreen" />
    <HeaderPage v-if="!isMapFullscreen" />
  </div>
  <div class="mobile-only">
    <!-- <MobileHeader v-if="!isMapFullscreen && isMobile" /> -->
    <MobileHeader
      v-if="!isMapFullscreen && isMobile"
      :accepted-order="acceptedOrderDetails"
    />
  </div>
  <section id="home" class="home-wrapper section-b-space overflow-hidden">
    <div class="background-effect">
      <div class="main-circle">
        <div class="main-circle circle-1">
          <div class="main-circle circle-2"></div>
        </div>
      </div>
    </div>
  </section>
  <section class="service-center-wrapper py-5 bg-light service-center-page">
    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-12 text-center">
          <h2 class="fw-bold text-primary">Service Center</h2>
          <p class="text-muted">Connect with us through your favorite platforms</p>
        </div>
      </div>

      <div class="row text-center">
        <!-- Facebook -->
        <div class="col-md-4 col-12 mb-4">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body">
              <i class="ri-facebook-circle-fill text-primary fs-1 mb-2"></i>
              <h5 class="card-title">Facebook</h5>
              <p class="card-text">Follow us for updates and promotions.</p>
              <a
                href="https://facebook.com"
                target="_blank"
                class="btn btn-outline-primary btn-sm"
              >
                Visit Page
              </a>
            </div>
          </div>
        </div>

        <!-- WeChat -->
        <div class="col-md-4 col-12 mb-4">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body">
              <i class="ri-wechat-fill text-success fs-1 mb-2"></i>
              <h5 class="card-title">WeChat</h5>
              <p class="card-text">Chat with us for support and inquiries.</p>
              <a href="#" class="btn btn-outline-success btn-sm"> Open WeChat </a>
            </div>
          </div>
        </div>

        <!-- Telegram -->
        <div class="col-md-4 col-12 mb-4">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body">
              <i class="ri-telegram-fill text-info fs-1 mb-2"></i>
              <h5 class="card-title">Telegram</h5>
              <p class="card-text">Join our community channel today.</p>
              <a
                href="https://t.me/yourchannel"
                target="_blank"
                class="btn btn-outline-info btn-sm"
              >
                Join Telegram
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <FooterBarPage></FooterBarPage>
</template>

<script setup>
import FooterBarPage from "../layout/FooterBarPage.vue";
import NavPage from "../navigation/NavPage.vue";
</script>

<style scoped>
.service-center-page {
  background-color: #f8f9fa;
  min-height: 100vh;
  /* padding-top: 80px; */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border-radius: 30px; /* လှပတဲ့ round ပုံစံ */
  padding: 30px;
  margin-top: -20px; /* Header နဲ့ ပေါင်းသွားအောင် */
  z-index: 1;
  position: relative;
}
</style>
